import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../../../../../../components/global/FormGroup';
import Alert from '../../../../../../../components/global/Alert';
import { getFormikTouchedErrors } from '../../../../../../../util/formik';
import { EVENT_DETAILS_CONTEXT } from '../utils';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email_address: PropTypes.string,
  }),
  values: PropTypes.shape({
    name: PropTypes.string,
    date: PropTypes.string,
    anniversary_type: PropTypes.string,
    event_date: PropTypes.string,
  }).isRequired,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  context: PropTypes.oneOf(Object.values(EVENT_DETAILS_CONTEXT)),
};

const FundraiserEventDetails = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  context,
}) => {
  const errorList = Object.values(getFormikTouchedErrors(errors, touched));

  return (
    <Fragment>
      <FormGroup
        id="name"
        name="name"
        error={!!errors.name}
        label={
          context === EVENT_DETAILS_CONTEXT.SLIDESHOW
            ? 'Slideshow Name'
            : 'Event Name'
        }
        placeholder="Enter event name here..."
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.name}
      />
      <FormGroup
        id="charity_name"
        name="charity_name"
        error={!!errors.charity_name}
        label="Name of charity"
        placeholder="Enter name of charity here..."
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.charity_name}
      />

      {errorList.length > 0 && (
        <Alert type="danger" className="mt-1 text-normal">
          <ul className="mb-0">
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}
    </Fragment>
  );
};

FundraiserEventDetails.propTypes = propTypes;

export default FundraiserEventDetails;
